import { render, staticRenderFns } from "./bank-info.vue?vue&type=template&id=bb0c01ae&scoped=true"
import script from "./bank-info.vue?vue&type=script&lang=js"
export * from "./bank-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0c01ae",
  null
  
)

export default component.exports